import { addReferenceEcheancierToLigneCommande }
  from '@/services/commande/echeancierFacturation/addReferenceEcheancierToLigneCommande';

export default function updateLignesCommandeWithPanierAndType(
  lignesCommandes, type, panier, devisCommande, tauxTva,
) {
  const newLignes = [];
  lignesCommandes.forEach((ligne) => {
    if (ligne.typeProduit !== type) {
      newLignes.push(ligne);
      return;
    }
    const indexLignePanier = panier.findIndex((panierLigne) => {
      return panierLigne.ordre === ligne.ordre;
    });
    if (indexLignePanier > -1) {
      panier.splice(indexLignePanier, 1);
      newLignes.push(ligne);
    }
  });
  panier.forEach((ligne) => {
    addReferenceEcheancierToLigneCommande(ligne, devisCommande);
    if (tauxTva !== null && tauxTva !== undefined) {
      ligne.tauxTva = tauxTva;
      if (ligne.lignesCommande) {
        ligne.lignesCommande.forEach((ligneEnfant) => {
          ligneEnfant.tauxTva = tauxTva;
        });
      }
    }
    newLignes.push(ligne);
  });
  return newLignes;
}
